<template>
  <div v-if="errors && errors.length > 0" class="text-start">
    <div class="d-flex align-items-center mb-1 pb-2 border-bottom">
      <div class="badge rounded-pill bg-danger-subtle text-danger px-3  ">
        <font-awesome-icon icon="circle-exclamation" class="me-2" />
        <span class="fw-bold">{{ errors.length }} Validation Errors</span>
      </div>
    </div>

    <div class="error-scroll-container px-1">
      <div
        v-for="(error, index) in errors"
        :key="index"
        class="error-item d-flex align-items-start gap-3 py-2 border-bottom"
      >
        <div class="error-index">
          {{ index + 1 }}
        </div>

        <div class="flex-grow-1 overflow-hidden">
          <div class="path-breadcrumb d-flex align-items-center flex-wrap gap-1 mb-1">
            <template v-for="(segment, sIndex) in splitPath(error.path)" :key="sIndex">
              <span class="segment-text">{{ segment }}</span>
              <font-awesome-icon
                v-if="sIndex < splitPath(error.path).length - 1"
                icon="chevron-right"
                class="separator-icon"
              />
            </template>
          </div>

          <div class="error-message">
            {{ error.message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  const props = defineProps({
    errors: { type: Array, required: true }
  });

  const splitPath = (path) => {
    if (!path) return [];
    return path.split(' > ').filter(s => s.trim() !== '');
  };
</script>

<style scoped>
   .error-scroll-container {
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

   .error-scroll-container::-webkit-scrollbar {
    width: 6px;
  }
  .error-scroll-container::-webkit-scrollbar-thumb {
    background-color: #dee2e6;
    border-radius: 10px;
  }

  .error-item:last-child {
    border-bottom: none !important;
  }

   .error-index {
    width: 24px;
    height: 24px;
    background: #f8d7da;
    color: #b02a37;
    font-size: 0.75rem;
    font-weight: 800;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .path-breadcrumb {
    line-height: 1;
  }

  .segment-text {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
  }

  .separator-icon {
    font-size: 0.55rem;
    color: #adb5bd;
  }

  .error-message {
    font-size: 0.95rem;
    font-weight: 600;
    color: #212529;
    line-height: 1.4;
  }

  /* Subtle animation when modal opens */
  .error-item {
    animation: slideIn 0.3s ease forwards;
    opacity: 0;
  }

  @keyframes slideIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
</style>
